import { createApp, configureCompat } from 'vue'
import installConveniaComponents from '@convenia/components'
import { ConveniaFeedbacks } from '@convenia/utils'

import CAdd from '@convenia/components/CAdd'
import CBottomBar from '@convenia/components/CBottomBar'
import CButton from '@convenia/components/CButton'
import CCard from '@convenia/components/CCard'
import CCharacter from '@convenia/components/CCharacter'
import CCropper from '@convenia/components/CCropper'
import CDivider from '@convenia/components/CDivider'
import CFeedbacks from '@convenia/components/CFeedbacks'
import CFile from '@convenia/components/CFile'
import CFileList from '@convenia/components/CFileList'
import CFlag from '@convenia/components/CFlag'
import { CFormBuilder } from '@convenia/components/CFormBuilder'
import CFormBuilderModal from '@convenia/components/CFormBuilderModal'
import CIcon from '@convenia/components/CIcon'
import CInfoHeader from '@convenia/components/CInfoHeader'
import CLoader from '@convenia/components/CLoader'
import CModal from '@convenia/components/CModal'
import CPreview from '@convenia/components/CPreview'
import CProgress from '@convenia/components/CProgress'
import { CRadioButton } from '@convenia/components/CRadioButton'
import CShadowed from '@convenia/components/CShadowed'
import CTitle from '@convenia/components/CTitle'
import { CUpload } from '@convenia/components/CUpload'

import App from './App.vue'
import router from './router'
import store from './store'

// @convenia/components .next files are written for Vue 3 semantics. Only the
// Vue 2 APIs still used by files shared with the Vue 2.7 build stay enabled.
// Never enable INSTANCE_LISTENERS or COMPONENT_V_MODEL: they strip listeners
// from $attrs and rewrite v-model, breaking the .next components
configureCompat({
  MODE: 3,
  OPTIONS_BEFORE_DESTROY: true,
  OPTIONS_DESTROYED: true,
  INSTANCE_SCOPED_SLOTS: true,
  // VCalendarCompat reads $children to reach the v-calendar controller
  INSTANCE_CHILDREN: true
})

const app = createApp(App)

app.provide('isVue2', false)

app.use(router)
app.use(store)
app.use(installConveniaComponents)
app.use(ConveniaFeedbacks, { store })

Object.entries({
  CAdd,
  CBottomBar,
  CButton,
  CCard,
  CCharacter,
  CCropper,
  CDivider,
  CFeedbacks,
  CFile,
  CFileList,
  CFlag,
  CFormBuilder,
  CFormBuilderModal,
  CIcon,
  CInfoHeader,
  CLoader,
  CModal,
  CPreview,
  CProgress,
  CRadioButton,
  CShadowed,
  CTitle,
  CUpload
}).forEach(([ name, component ]) => app.component(name, component))

app.mount('#app')
